<template>
  <div id="contenedor-agregar-proyecto-documento-tipo">
    <v-form  v-model="formularioValido" ref="formAgregarProyectoDocumentoTipo">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar tipo de documento
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
              label="Descripción"
              v-model="documentoTipo.descripcion"
              :rules="[mixReglas.requerido]"
              required>
            </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarProyectoDocumentoTipo"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixProyectoDocumentosTipos from './mixProyectoDocumentosTipos';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AgregarProyectoDocumentoTipo',
  mixins: [mixProyectoDocumentosTipos],
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      documentoTipo: {
        descripcion: '',
      },
    };
  },
  methods: {
    cerrar() {
      this.$refs.formAgregarProyectoDocumentoTipo.reset();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss" scoped></style>
